export const SET_CONCEDENTES = "CONCEDENTES/SET_CONCEDENTES";
export const SET_CONCEDENTE = "CONCEDENTES/SET_CONCEDENTE";
export const SET_PAGINATION = "CONCEDENTES/SET_PAGINATION";
